


// /* ===============================
//    CYCLE COUNT – HEADER FIELDS
//    =============================== */

// export const cycleCountHeaderFields = [
//     {
//         name: "cyclecountkey",
//         label: "Cycle Count Key"
//     },
//     {
//         name: "Warehouse",
//         label: "Warehouse"
//     },
//     {
//         name: "CreatedBy",
//         label: "Created By"
//     },
//     {
//         name: "owner",
//         label: "Owner"
//     },
//     {
//         name: "status",
//         label: "Status"
//     },
//     {
//         name: "item",
//         label: "Item"
//     },
//     {
//         name: "location",
//         label: "Location"
//     },

//     // 🔥 API KEYS WITH SPACES (VERY IMPORTANT)
//     {
//         name: "adjustment reason",
//         label: "Adjustment Reason"
//     },
//     {
//         name: "reference num",
//         label: "Reference No"
//     },
//     {
//         name: "initiating document id",
//         label: "Initiating Document ID"
//     }
// ];


// /* ===============================
//    CYCLE COUNT – DETAIL TABLE COLUMNS
//    =============================== */

// export const cycleCountDetailColumns = [
//     {
//         key: "cyclecount detail key",
//         label: "Detail Key"
//     },
//     {
//         key: "owner",
//         label: "Owner"
//     },
//     {
//         key: "item",
//         label: "Item"
//     },
//     {
//         key: "description",
//         label: "Description"
//     },
//     {
//         key: "status",
//         label: "Status"
//     },
//     {
//         key: "location",
//         label: "Location"
//     },
//     {
//         key: "lpn",
//         label: "LPN"
//     },
//     {
//         key: "pack",
//         label: "Pack"
//     },
//     {
//         key: "qty counted",
//         label: "Qty Counted"
//     },
//     {
//         key: "system count",
//         label: "System Count"
//     },
//     {
//         key: "adjusted count",
//         label: "Adjusted Count"
//     },
//     {
//         key: "cost",
//         label: "Cost"
//     },
//     {
//         key: "extend cost",
//         label: "Extended Cost"
//     },
//     {
//         key: "selected qty",
//         label: "Selected Qty"
//     },
//     {
//         key: "notes",
//         label: "Notes"
//     }
// ];








/* ===============================
   CYCLE COUNT – HEADER FIELDS
   =============================== */
export const cycleCountHeaderFields = [
    { name: "cyclecountkey", label: "Cycle Count Key" },
    { name: "Warehouse", label: "Warehouse" },
    { name: "CreatedBy", label: "Created By" },
    { name: "owner", label: "Owner" },
    { name: "status", label: "Status" },
    { name: "item", label: "Item" },
    { name: "location", label: "Location" },
    { name: "adjustment reason", label: "Adjustment Reason" },
    { name: "reference num", label: "Reference No" },
    { name: "initiating document id", label: "Initiating Document ID" },
    { name:"CreatedBy", label:"Created By"},
    {
        name: "createdDate",
        label: "Created Date",
        type: "text",
        readOnly: true
    },

];

/* ===============================
   CYCLE COUNT – DETAIL TABLE COLUMNS
   (CommonDataTable SAFE)
   =============================== */
export const cycleCountDetailColumns = [
    { field: "lineNo", headerName: "Line#", width: 90, sortable: false },
    { field: "item", headerName: "Item", width: 140, sortable: false },
    { field: "description", headerName: "Description", width: 220, sortable: false },
    { field: "location", headerName: "Location", width: 120, sortable: false },
    { field: "status", headerName: "Status", width: 140, sortable: false },
    { field: "qty_counted", headerName: "Qty Counted", width: 130, sortable: false },
    { field: "system_count", headerName: "System Count", width: 140, sortable: false },
    { field: "adjusted_count", headerName: "Adjusted Count", width: 150, sortable: false },
    { field: "lpn", headerName: "LPN", width: 120, sortable: false },
    { field: "pack", headerName: "Pack", width: 120, sortable: false },
    { field: "notes", headerName: "Notes", width: 250, sortable: false },
    {field : "owner", headerName : "Owner", width: 140, sortable: false}
];
